import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../../lib/PropTypes';

import Blocks from '../../blocks/Blocks';
import Location from '../../partials/NhlLocation';
import PageTitle from '../../partials/PageTitle';

import styles from '../../../../styles/themes/nhl/locations-allstar.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

function LocationsAllstarPage({ page }) {
    const { title, description = null, locations = [], blocks = [] } = page;

    // first item is featured
    const featuredLocation = useMemo(() => (locations.length > 0 ? locations[0] : {}), [locations]);

    const finalLocations = useMemo(
        () =>
            locations.map((item, index) => ({ ...item, index })).filter((item, index) => index > 0),
        [locations],
    );

    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <PageTitle className={styles.title} title={title} />
                {description !== null ? (
                    <div className={styles.description}>{description}</div>
                ) : null}
                <Location
                    className={styles.featuredLocation}
                    featured
                    location={featuredLocation}
                />
                <div className={styles.description}>
                    <FormattedMessage
                        defaultMessage="The arena experience can also be found at our other partner bars!"
                        description="All-Star page label"
                    />
                </div>
                <Blocks blocks={blocks} />
            </div>

            <ul className={styles.items}>
                {(finalLocations || []).map((location, locationIndex) => (
                    <li className={styles.item} key={`location-${locationIndex + 1}`}>
                        <Location className={styles.location} location={location} />
                    </li>
                ))}
            </ul>
        </div>
    );
}

LocationsAllstarPage.propTypes = propTypes;

export default LocationsAllstarPage;
